<template>
    <modal
        modalId="team-modal"
        v-model="showModal"
        :title="generateModalTitle('team')"
        @submit="submitData"
        :loading="loading">
        <template #body>
            <form :data-url='selectedUrl ? selectedUrl : TEAMS'
                  method="POST"
                  ref="form">
                <div class="form-group">
                    <div class="row">
                        <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                            <label class="text-left d-block mb-lg-2 mb-xl-0">{{ $t('name') }}</label>
                        </div>
                        <div class="col-lg-8 col-xl-8">
                            <app-input
                                type="text"
                                :placeholder="$placeholder('name')"
                                :required="true"
                                v-model="formData.name"
                                :error-message="$errorMessage(errors, 'name')"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="row">
                        <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                            <label class="text-left d-block mb-lg-2 mb-xl-0">{{ $t('description') }}</label>
                        </div>
                        <div class="col-lg-8 col-xl-8">
                            <app-input
                                type="textarea"
                                :placeholder="$placeholder('description')"
                                v-model="formData.description"
                                :error-message="$errorMessage(errors, 'description')"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
import {ModalMixin} from "../../../mixins/ModalMixin";
import FormHelperMixins from "../../../mixins/global/FormHelperMixins";
import {TEAMS} from "../../../config/ApiUrl";

export default {
    name: "TeamFormModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            formData: {
                name: '',
                description: '',
            },
            TEAMS,
        }
    },
    methods: {
        afterSuccess({data}) {
            this.formData = {};
            $('#team-modal').modal('hide');
            this.toastAndReload(data.message, 'team-table')
            this.$emit('input', false);
        },
        afterSuccessFromGetEditData({data}) {
            this.preloader = false
            this.formData = data
        }
    }
}
</script>
